module.exports = __webpack_public_path__ + "static/media/Raleway-Medium.2ec85574.ttf";